import { useEffect, useState } from "react";
import api from "../lib/api";

// Cached at module level so it's fetched once per page load
let _cache = null;
let _promise = null;

export function useUsersMap() {
  const [map, setMap] = useState(_cache);
  useEffect(() => {
    if (_cache) { setMap(_cache); return; }
    if (!_promise) {
      _promise = api.get("/admin/users-map")
        .then((r) => { _cache = r.data || {}; return _cache; })
        .catch(() => { _cache = {}; return _cache; });
    }
    _promise.then(setMap);
  }, []);
  return map || {};
}

export function clearUsersMapCache() { _cache = null; _promise = null; }

export function OwnerPill({ userId, className = "" }) {
  const map = useUsersMap();
  const owner = userId ? map[userId] : null;
  if (!owner) {
    // Fallback: show truncated user_id if owner not in map yet
    return userId ? (
      <span className={`inline-flex items-center text-[9px] font-mono-shelv tracking-widest uppercase bg-black/5 text-[#717680] px-1.5 py-0.5 ${className}`} data-testid="owner-pill-unknown">
        {String(userId).slice(0, 12)}…
      </span>
    ) : null;
  }
  const label = owner.name || owner.email || "—";
  const short = label.split(" ")[0]; // first name
  return (
    <span
      title={`${owner.name || ""} ${owner.email ? `<${owner.email}>` : ""}`.trim()}
      className={`inline-flex items-center gap-1 text-[9px] font-mono-shelv tracking-widest uppercase bg-[#0A0A0A]/5 text-[#0A0A0A] px-1.5 py-0.5 ${className}`}
      data-testid={`owner-pill-${userId}`}
    >
      <span className="w-1 h-1 rounded-full bg-[#D90429]" />
      {short}
    </span>
  );
}
